import { render } from "./SidebarLogo.vue?vue&type=template&id=5e27001a&scoped=true"
import script from "./SidebarLogo.vue?vue&type=script&lang=ts"
export * from "./SidebarLogo.vue?vue&type=script&lang=ts"

import "./SidebarLogo.vue?vue&type=style&index=0&id=5e27001a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e27001a"

export default script